import(/* webpackMode: "eager" */ "D:\\lang\\switchboard\\next-shadcn-dashboard-starter\\app\\not-found.tsx");
